<template>
    <div>
        <v-row class="mt-n10">
            <v-col :cols="12">
                <BillingItemsTable 
                :selectedInvoice="selectedQuote" 
                itemLabel="Quotation" 
                referenceNumber="quote_number"
                @billing-added="refreshBillingEntries"
                ></BillingItemsTable>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BillingItemsTable from '@/modules/CaseManager/BillingItemsTable.vue';

export default {
    name: "Quotations",
    props:{
        selectedQuote:{
            default: null
        },
    },
    components: { BillingItemsTable},
    methods:{
        refreshBillingEntries(billingEntries){
            this.selectedQuote.billingEntries = billingEntries

        },
    }
}
</script>